var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visibility",
    clipPath: "url(#clip0_2243_901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.85279 14L14.3528 2M6 12.7C6.64732 12.9021 7.32189 13.0032 8 13C10.7333 13.0467 13.5067 11.1267 15.2133 9.24C15.3974 9.03752 15.4995 8.77367 15.4995 8.5C15.4995 8.22633 15.3974 7.96249 15.2133 7.76C14.5962 7.07792 13.9104 6.46132 13.1667 5.92M11.3928 4.84667C10.3437 4.30239 9.18129 4.01237 7.99945 4C5.33279 3.95333 2.53279 5.83333 0.78612 7.76C0.602015 7.96249 0.5 8.22633 0.5 8.5C0.5 8.77367 0.602015 9.03751 0.78612 9.24C1.73271 10.2982 2.84224 11.1984 4.07279 11.9067M5.99886 10.0467C5.63721 9.54494 5.46889 8.9295 5.52486 8.31356C5.58083 7.69761 5.85733 7.12259 6.3035 6.69427C6.74966 6.26596 7.33548 6.01315 7.9532 5.98235C8.57092 5.95156 9.17898 6.14485 9.66553 6.52667M10.5 8.5C10.5 8.8283 10.4353 9.15339 10.3097 9.45671C10.1841 9.76002 9.99991 10.0356 9.76777 10.2678C9.53562 10.4999 9.26002 10.6841 8.95671 10.8097C8.65339 10.9353 8.3283 11 8 11",
    stroke: "#040506",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2243_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.a246398fba17bd196f034f500b08adc2.svg";
export { ForwardRef as ReactComponent };